import type {
  BrowseSubscriptionPlanResponse,
  FeatureCatalog,
  Plan,
  PlanCardConfig,
} from '@aibees/shared/definition';
import { buildFeatureGroups } from './build-feature-groups';

const EMPTY_OPTIONS: BrowseSubscriptionPlanResponse = [];

export function buildPlanCardConfig(
  productId: string,
  catalog: FeatureCatalog,
  plans: Plan[]
): PlanCardConfig | null {
  const product = catalog.products.find((p) => p.id === productId);
  if (!product) return null;

  const productPlans = plans
    .filter((p) => p.product?.id === productId)
    .sort((a, b) => (a.amount ?? 0) - (b.amount ?? 0));

  const cheapest = productPlans[0];
  // Backend emits the literal string "true" / "false" for is_free — a truthy
  // check would match both, so we have to compare against the literal "true".
  const isFree =
    cheapest?.metadata.is_free === 'true' || cheapest?.amount === 0;
  const defaultCredit = cheapest ? Number(cheapest.metadata.request) : 0;
  const monthlyCreditRate =
    cheapest && defaultCredit > 0
      ? (cheapest.amount ?? 0) / (defaultCredit / 1000)
      : 0;

  return {
    title: `${product.name} Plan`,
    subtitle: product.description ?? '',
    monthlyCreditRate,
    yearlyCreditRate: 0,
    tagline: product.metadata.label,
    priceDescription: isFree ? 'Always free' : 'Per Month',
    featureGroups: buildFeatureGroups(productId, catalog),
    defaultCredit,
    options: EMPTY_OPTIONS,
    buttonText: isFree ? 'Get Started' : `Switch to ${product.name}`,
    disabled: false,
  };
}
